import { render, staticRenderFns } from "./addShortVideo.vue?vue&type=template&id=8ea1db6e&scoped=true&"
import script from "./addShortVideo.vue?vue&type=script&lang=js&"
export * from "./addShortVideo.vue?vue&type=script&lang=js&"
import style0 from "./addShortVideo.vue?vue&type=style&index=0&id=8ea1db6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea1db6e",
  null
  
)

export default component.exports